(function () {
  'use strict';

  function fileNameToIconClass() {
    return function (value) {
      if (!value) {
        return 'fa-file-o';
      }

      var extension = value.substr(value.lastIndexOf('.') + 1).toLowerCase();

      switch (extension) {
        case ('ppt'):
        case ('pptx'):
          return 'fa-file-powerpoint-o';
        case ('doc'):
        case ('docx'):
          return 'fa-file-word-o';
        case ('xls'):
        case ('xlsx'):
        case ('xlsm'):
        case ('csv'):
          return 'fa-file-excel-o';
        case ('zip'):
          return 'fa-file-zip-o';
        case ('tif'):
        case ('tiff'):
        case ('ai'):
        case ('jpg'):
          return 'fa-image-o';
        case ('pdf'):
          return 'fa-file-pdf-o';
        default:
          return 'fa-file-o';
      }
    };
  }

  angular.module('ecap.common').filter('fileNameToIconClass', fileNameToIconClass);
})();